<template>
  <b-form-group label="Detalhes do Aluguel" label-for="rent-details">
    <b-card class="mb-2">
      <b-row>
        <b-col>
          <b-form-group label="Cliente">
            <b-input
              class="border-0"
              readonly
              :value="toy.rent.customer.name"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Brinquedo">
            <b-input class="border-0" readonly :value="toy.name" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label="Período">
            <b-input
              class="border-0"
              readonly
              :value="`${toy.rent.period.time} min - ${formatCurrency(
                toy.rent.period.price
              )}`"
            />
          </b-form-group>
        </b-col>

        <b-col v-if="toy.rent.pausedTime > 0">
          <b-form-group label="Pausa">
            <b-input
              class="border-0"
              readonly
              :value="`${toy.rent.pausedTime} minuto(s)`"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group label="Tempo Extra">
        <b-textarea
          class="border-0"
          readonly
          :value="extraTimeStrings"
          no-resize
        />
      </b-form-group>

      <b-form-group v-if="!hideTotal" label="Valor Total">
        <b-input
          class="border-0"
          readonly
          :value="`R$ ${toy.rent.rentAmount}`"
        />
      </b-form-group>
    </b-card>
  </b-form-group>
</template>

<script>
import { formatCurrency } from '@/helpers/numbers'

export default {
  name: 'ToyRentDetails',
  props: {
    toy: {
      type: Object,
      required: true
    },
    hideTotal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    extraTimeStrings() {
      return this.toy.rent.extraTime
        .filter((entry) => entry.type === null)
        .map(
          (entry) =>
            `+ ${entry.minutes} minuto(s)${
              entry.reason ? ' - ' + entry.reason : ''
            }`
        )
        .join('\n')
    }
  },
  watch: {
    toy: {
      handler({ rent }) {
        // Emite valores pré-calculados para o componente pai
        this.$emit('update-rent-amount', rent.rentAmount)
        this.$emit('update-products-amount', rent.productsAmount || 0)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    formatCurrency(value) {
      return formatCurrency(value)
    }
  }
}
</script>
